@if (isLoading) {
  <div class="page-loader">
    <div class="loader">
    </div>
  </div>
}
<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <h3>Payroll Time Report</h3>
      </div>
      <div class="card mt-1">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-2">
              <div>
                <label for="range" class="form-label">Enter Payroll Period</label><span
              style="color:var(--al-danger);">*</span>
              <p-calendar id="range" appendTo="body" [(ngModel)]="selectedDates" selectionMode="range"
                placeholder="Select Range">
              </p-calendar>
            </div>
            @if (submitted && (!selectedDates||selectedDates.length==0)) {
              <span style="color:var(--al-danger)">Range
              is Required</span>
            }
          </div>
          <div class="col-sm-2">
            <div>
              <label for="practiceAreas" class="form-label">Select Practice Area</label><span
            style="color:var(--al-danger);">*</span>
            <p-multiSelect [maxSelectedLabels]="10000" id="practiceAreas" appendTo="body" defaultLabel="Select Practice Area"
              [(ngModel)]="selectedPracticeAreas" [style]="{'width':'100%'}"
              [panelStyle]="{'width':'400px'}" [options]="practiceAreas" optionLabel="description"
            optionValue="description"></p-multiSelect>
          </div>
          @if (submitted && (!selectedPracticeAreas || selectedPracticeAreas.length == 0)) {
            <span style="color:var(--al-danger)">
            Practice Area is Required</span>
          }
        </div>
        <div class="col-sm-2">
          <div>
            <label for="orgs" class="form-label">Select Organisation</label><span
          style="color:var(--al-danger);">*</span>
          <p-multiSelect [maxSelectedLabels]="10000" id="orgs" appendTo="body" defaultLabel="Select Organisation"
            [(ngModel)]="selectedOrgs" [style]="{'width':'100%'}"
            (onChange)="fetchMattersByOrgIds()"
            [panelStyle]="{'width':'400px'}" [options]="allOrganisations" optionLabel="name"
          optionValue="id"></p-multiSelect>
        </div>
        @if (submitted && (!selectedOrgs||selectedOrgs.length==0)) {
          <span style="color:var(--al-danger)">
          Organisation is Required</span>
        }
      </div>
      <div class="col-sm-2">
        <div>
          <label for="matters" class="form-label">Select Matter</label><span
        style="color:var(--al-danger);">*</span>
        <p-multiSelect [maxSelectedLabels]="10000" id="matters" appendTo="body" defaultLabel="Select Matter"
          [(ngModel)]="selectedMatters" [style]="{'width':'100%'}"
          [panelStyle]="{'width':'400px'}" [options]="allMatters" optionLabel="matterName"
        optionValue="matterId"></p-multiSelect>
      </div>
      @if (submitted && (!selectedMatters||selectedMatters.length==0)) {
        <span style="color:var(--al-danger)">
        Matter is Required</span>
      }
    </div>
    <div class="col-sm-2">
      <div>
        <label for="users" class="form-label">Select Users</label><span
      style="color:var(--al-danger);">*</span>
      <p-multiSelect [maxSelectedLabels]="10000" id="users" appendTo="body" defaultLabel="Select User"
        [(ngModel)]="selectedUsers" [style]="{'width':'100%'}"
        [panelStyle]="{'width':'400px'}" [options]="allUsers" optionLabel="mainEmail"
      optionValue="id"></p-multiSelect>
    </div>
    @if (submitted && (!selectedUsers||selectedUsers.length==0)) {
      <span style="color:var(--al-danger)">User
        is
      Required</span>
    }
  </div>
  <div class="col-sm-2" style="margin-top:2%">
    <input class="form-check-input check-input" type="checkbox" id="isSummaryOnly"
      [(ngModel)]="isSummaryOnly">
    <label class="form-check-label" for="isSummaryOnly">
      Summary Only
    </label>
  </div>
  <div class="col-sm-2 mt-4">
    <button class="btn btn-success" (click)="loadPayrollReportData()" pTooltip="Generate the payroll time report" appActionTooltip>Generate Report@if (generateLoader) {
      <i
        style="margin-left: 7px;"
      class="fa fa-solid fa-sync fa-spin"></i>
    }</button>
    <!-- <button class="btn btn-danger" style="margin-left: 7px;" (click)="exportReport()"> Export Report</button> -->
  </div>

</div>
</div>
</div>
</div>
</div>
</div>

@if (!showSummaryOnly) {
  <div class="card">
    <div class="row">
      <div  class="button-items m-2" style="float: right;">
        <button class="btn btn-primary btn-sm" (click)="exportReport(ndt)" pTooltip="Export table to CSV" appActionTooltip><i
        class="mdi mdi-download"></i></button>
        <button class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="ndt.clear()" pTooltip="Clear column filters and sorting" appActionTooltip>Clear<i
        class="mdi mdi-filter-remove"></i></button>
      </div>
    </div>
    <p-table #ndt [columns]="nonSummaryCols" [value]="reportNonSummaryList" [scrollable]="true" scrollHeight="250px">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="orgName">Organisation Name
            <p-sortIcon field="orgName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="orgName" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="matterName" >Matter Name
            <p-sortIcon field="matterName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="matterName" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="projectName">Project Name
            <p-sortIcon field="projectName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="projectName" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="projTaskName" >Task Name
            <p-sortIcon field="projTaskName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="projTaskName" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="practiceArea" >Practice Area
            <p-sortIcon field="practiceArea"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="practiceArea" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="trDate" >Time Record Date
            <p-sortIcon field="trDate"></p-sortIcon>
            <p-columnFilter type="date" field="trDate"
              [showOperator]="false" [matchModeOptions]="matchModeOptionsDate" [showAddButton]="false"
            display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="trDescription" >Time Record Description
            <p-sortIcon field="trDescription"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="trDescription" display="menu"></p-columnFilter>
          </th>
          <th pSortableColumn="userName">User Name
            <p-sortIcon field="userName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="userName" display="menu"></p-columnFilter>
          </th>
          <th>Total Project Time (HH:MM)</th>
          <th>Total Project Time (Decimals)</th>
          <th>Total User Time (HH:MM)</th>
          <th>Total User Time (Decimals)</th>
          <th>Total Task Time (HH:MM)</th>
          <th>Total Task Time (Decimals)</th>
          <th>Total Time Record Time (HH:MM)</th>
          <th>Total Time Record Time (Decimals)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-report>
        <tr>
          <td>
            {{report.orgName}}
          </td>
          <td >
            {{report.matterName}}
          </td>
          <td>
            {{report.projectName}}
          </td>
          <td >
            {{report.projTaskName}}
          </td>
          <td >
            {{report.practiceArea}}
          </td>
          <td >
            {{report.trDateStr}}
          </td>
          <td >
            {{report.trDescription}}
          </td>
          <td>
            {{report.userName}}
          </td>
          <td>
            {{report.totalProjTime}}
          </td>
          <td>
            {{report.totalProjTimeDecimal}}
          </td>
          <td>
            {{report.totaltime}}
          </td>
          <td>
            {{report.totaltimeDecimal}}
          </td>
          <td >
            {{report.totalTaskTime}}
          </td>
          <td >
            {{report.totalTaskTimeDecimal}}
          </td>
          <td >
            {{report.loggedTrTime}}
          </td>
          <td >
            {{report.loggedTrTimeDecimal}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns && columns.length">
            {{ errorMsg ? errorMsg : 'No records found' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (showSummaryOnly) {
  <div class="card">
    <div  class="button-items m-2" style="float: right;">
      <button class="btn btn-primary btn-sm" (click)="exportReport(dt)"
        pTooltip="Export table to CSV" appActionTooltip><i  class="mdi mdi-download"></i></button>
        <button class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="dt.clear()" pTooltip="Clear column filters and sorting" appActionTooltip>Clear<i
        class="mdi mdi-filter-remove"></i></button>
      </div>
      <p-table #dt [columns]="summaryCols" [value]="reportSummaryList" [scrollable]="true" scrollHeight="250px">
        <!-- <ng-template pTemplate="caption">
        <div class="flex" style="float: right;">
          <button type="button" pButton pRipple icon="pi pi-file" (click)="exportReport(dt)" class="mr-2"
          title="CSV"></button>
          <button class="btn btn-primary btn-sm" style="margin-left: 10px;" (click)="dt.clear()">Clear<i
          class="mdi mdi-filter-remove"></i></button>
        </div>
      </ng-template> -->
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="userName">User Name
            <p-sortIcon field="userName"></p-sortIcon>
            <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptions"
            type="text" matchMode="contains" field="userName" display="menu"></p-columnFilter>
          </th>
          <th>Total Time (HH:MM)</th>
          <th>Total Time (Decimal)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-report>
        <tr>
          <td>
            {{report.userName}}
          </td>
          <td>
            {{report.totaltime}}
          </td>
          <td>
            {{report.totaltimeDecimal}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns && columns.length">
            {{ errorMsg ? errorMsg : 'No records found' }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}